(() => {
  const configElement = document.getElementById('cocolab-reward-milestones-config');
  if (!configElement) return;
  const { freeGift } = JSON.parse(configElement.textContent);

  const update = () => {
    document.querySelectorAll('[data-skio-name="reward-milestones-container"] [data-skio-name="rewards-card-item"]').forEach((item) => {
      const title = item.querySelector('[data-skio-name="rewards-card-item-pill-product-title"]');
      const image = item.querySelector('[data-skio-name="rewards-card-item-product-image"]');
      const caption = item.querySelector('[data-skio-name="rewards-card-item-caption"]');
      if (!image || !caption) return;

      const claimed = /\b(claimed|redeemed|received)\b/i.test(caption.textContent);
      item.classList.toggle('cocolab-surprise-gift', !claimed);
      let label = title?.parentElement.querySelector('.cocolab-free-gift-label');
      if (!claimed && title && !label) {
        label = document.createElement('span');
        label.className = `${title.className} cocolab-free-gift-label`;
        label.textContent = freeGift;
        title.after(label);
      }
      if (!claimed && image.getAttribute('aria-label') !== freeGift) {
        image.setAttribute('aria-label', freeGift);
      } else if (claimed && image.getAttribute('aria-label') === freeGift) {
        image.setAttribute('aria-label', caption.textContent.trim());
      }
    });
  };

  update();
  const observer = new MutationObserver(update);
  observer.observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  window.addEventListener('pagehide', (event) => {
    if (!event.persisted) observer.disconnect();
  });
})();
